import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ApiQWorkardsEnv } from '@qaroni-core/config/apis/api-qworkards/api-qworkards.config';
import { TimezoneApiObject } from '@qaroni-core/types/timezone/timezone-response';

@Injectable({
  providedIn: 'root',
})
export class TimezoneHttpService {
  private http = inject(HttpClient);

  getAllTimezones$() {
    const url = `${ApiQWorkardsEnv.baseUrl}/timezones`;
    return this.http.get<TimezoneApiObject>(url, { observe: 'response' });
  }
}
